import * as Sentry from '@sentry/browser'
import { getSentryConfig, getSentryUser } from '../lib/sentry'

const sentryConfig = getSentryConfig()
if (sentryConfig) {
  Sentry.init({
    ...sentryConfig,
    integrations: [Sentry.browserTracingIntegration({ enableLongAnimationFrame: false })],
    tracesSampleRate: 0.01,
  })

  const user = getSentryUser()
  if (user) {
    Sentry.setUser(user)
  }
}

import "controllers"
